import { render, staticRenderFns } from "./FarmsEditFormFields.vue?vue&type=template&id=51310446&scoped=true"
import script from "./FarmsEditFormFields.vue?vue&type=script&lang=js"
export * from "./FarmsEditFormFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51310446",
  null
  
)

export default component.exports